<app-layouts>
    <div *ngIf="mainService.isBrowser" content>
      <app-create-exhibition [isProfile]="true"></app-create-exhibition>
    </div>
</app-layouts>
